import WelcomeToSession from '~/pages/default-apps/Home/components/WelcomeToSession'
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import {ImageSkeleton} from '~/components';
import {Fragment} from "react";
function AIChatbotHome() {
    return (
        <Fragment>
            <WelcomeToSession bodyEmphasis={false} />
            <div className="container-medium px-lg-7 px-xxl-3">
                <div className="position-relative z-2">
                    <div
                        className="row mt-12 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
                        <div className="col-lg-5">
                            <ImageSkeleton heightLoading={200} id={46} className={"feature-image img-fluid mb-9 mb-lg-0 d-dark-none"}/>
                        </div>
                        <div className="col-lg-6">
                            <h4 className="fw-bolder mb-3 lh-sm">AI Breakthrough Whisperer – Unlocking the Mind and Soul’s
                                Potential</h4>
                            <p className="mb-4 px-md-7 px-lg-0 fs-8-1">AI Breakthrough Whisperer drives growth and self-mastery
                                through bold Q&A, revealing hidden truths about life, reality, dreams, and the self.</p>
                        </div>
                    </div>
                    <div
                        className="row mt-2 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
                        <div className="col-lg-5 order-0 order-lg-1">
                            <ImageSkeleton heightLoading={200} id={47} className={"feature-image img-fluid mb-9 mb-lg-0 d-dark-none"}/>
                        </div>
                        <div className="col-lg-6">
                            <h4 className="fw-bolder mb-3 lh-sm">Hidden Love and Happiness – Unlocking the Soul’s True
                                Power</h4>
                            <p className="mb-4 px-md-7 px-lg-0 fs-8-1">Discover hidden happiness through self-mastery, courage,
                                and self-healing, unlocking inner wisdom, love, and longevity for life and beyond.</p>
                        </div>
                    </div>
                    <div
                        className="row mt-2 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
                        <div className="col-lg-5">
                            <ImageSkeleton heightLoading={200} id={48} className={"feature-image img-fluid mb-9 mb-lg-0 d-dark-none"}/>
                        </div>
                        <div className="col-lg-6 text-center text-lg-start">
                            <h4 className="fw-bolder mb-3 lh-sm">AI BreakThrough Chatbot – Awakening Inner Power,
                                Intelligence, and True Happiness</h4>
                            <p className="mb-4 px-md-7 px-lg-0 fs-8-1">Unleash hidden potential through AI-guided
                                self-rejuvenation, wisdom, and spiritual growth, transcending conventional limits to
                                achieve love, intelligence, and lasting happiness.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AIChatbotHome;